module.exports = __webpack_public_path__ + "static/media/exploration.5ac30c7a.png";